import { render } from "./recruit.vue?vue&type=template&id=53e619ec&scoped=true"
import script from "./recruit.vue?vue&type=script&lang=js"
export * from "./recruit.vue?vue&type=script&lang=js"

import "./recruit.vue?vue&type=style&index=0&id=53e619ec&scoped=true&lang=css"
import "./recruit.vue?vue&type=style&index=1&id=53e619ec&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e619ec"]])

export default __exports__